exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.create-customer-properties[data-v-312becba] {\n  position: relative;\n  margin-bottom: 15px;\n}\n.fix-button-margin[data-v-312becba] {\n  margin: -6px;\n}\n.create-button[data-v-312becba] {\n  margin-top: 15px;\n}\n.address-label[data-v-312becba] {\n  color: rgba(0, 0, 0, 0.85);\n  font-size: 14px;\n  font-weight: 500;\n}\n.padding-bottom[data-v-312becba] {\n  margin-bottom: 15px;\n}\n", ""]);

// exports
